import { render, staticRenderFns } from "./bannerTemplate.vue?vue&type=template&id=07a77806&scoped=true"
import script from "./bannerTemplate.vue?vue&type=script&lang=js"
export * from "./bannerTemplate.vue?vue&type=script&lang=js"
import style0 from "./bannerTemplate.vue?vue&type=style&index=0&id=07a77806&prod&scoped=true&lang=css"
import style1 from "./bannerTemplate.vue?vue&type=style&index=1&id=07a77806&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a77806",
  null
  
)

export default component.exports